import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createTestimonial } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useCreateTestimonial() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createItemMutate, isPending } = useMutation({
        mutationFn: createTestimonial,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
            navigate("/testimonials");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create testimonial");
        },
    });

    return { createItemMutate, isPending };
}
